








import { FormatOptions, formatMetricValue, formatModbusMetricValue } from '@/features/core/util/metric-formatters';
import { BooleanProp, ObjectProp, OptionalProp, StringProp } from '@/util/prop-decorators';
import { Component, Vue } from 'vue-property-decorator';
import { DomainUiMetricSpotFragment } from './__generated__/DomainUiMetricSpotFragment';
import moment from 'moment';

@Component
export default class MetricValue extends Vue {
  @StringProp()
  private readonly name?: string;

  @ObjectProp()
  private readonly spot?: DomainUiMetricSpotFragment;

  @OptionalProp()
  private readonly value?: string | number;

  @OptionalProp()
  private readonly time?: string;

  @OptionalProp()
  private readonly unit?: string;

  @ObjectProp()
  private readonly formatOptions?: FormatOptions;

  @BooleanProp()
  private readonly inline!: boolean;

  @StringProp('–')
  private readonly emptyMessage!: string;

  // this is currently not used, but may be in the future when unit and normalization factor is configurable
  private get configuration(): DomainUiMetricSpotFragment['metricConfigurations'][number] | undefined {
    return this.spot?.metricConfigurations.find(({ name }) => name === this.name);
  }

  private get formattedValue(): string | undefined {
    if (this.value === undefined) return undefined;

    if (this.name === 'durationLastReadout' && this.time !== undefined) {
      return this.getTimeStampOrMetricValue();
    }

    if (this.isModbusMetric()) {
      if (!this.configuration?.unit) return this.value.toString();
      return formatModbusMetricValue(this.name ?? '', this.value, { decimalsRound: 2 }, this.configuration.unit);
    }

    return formatMetricValue(this.name ?? '', this.value, this.formatOptions, this.unit);
  }

  private isModbusMetric(): boolean {
    return this.spot?.role === 'HEATING_CONTROL' || !!this.configuration?.unit;
  }

  private getTimeStampOrMetricValue(): string {
    const timeStamp = moment(this.time).valueOf() - Number(this.value) * 1000;
    return moment(timeStamp).format('L LTS');
  }
}
